import AsyncStorage from "@react-native-async-storage/async-storage";

type storage_keys_type =
    "scheme"
    |"api_key"
    |"lang"
    |"branch"
    |"order_type"
    |"table_id"
    |"notification_denied_on_modal"
    |"pwa_manual_installation_showed"
    |"user_phone_number"
    |"push-endpoint";

const storageFunctions = {
    saveData: async (key:storage_keys_type, value:string) => {
        try {
            await AsyncStorage.setItem(
                key,
                value,
            );
            return true;
        } catch (error) {
            return false;
        }
    },
    getData: async (key:storage_keys_type) => {
        try {
            return await AsyncStorage.getItem(key);
        } catch (e) {
            return null;
        }

    },
    deleteData: async (key:storage_keys_type) => {
        try {
            return await AsyncStorage.removeItem(key);
        } catch (e) {
            return null;
        }

    },
}

export {storageFunctions};